/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_UnscheduledInputs */

const en_tl_unscheduled = /** @type {(inputs: Tl_UnscheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unscheduled`)
};

const de_tl_unscheduled = /** @type {(inputs: Tl_UnscheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Termin`)
};

/**
* | output |
* | --- |
* | "Unscheduled" |
*
* @param {Tl_UnscheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_unscheduled = /** @type {((inputs?: Tl_UnscheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_UnscheduledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_unscheduled(inputs)
	return en_tl_unscheduled(inputs)
});